/**
 * author: Qian.qianchen 2018-10-31
 * description: 成品稿库-电视台
 */
'use strict';
angular.module('videoStockModule', [])
    .controller('videoStockCtrl', ['$scope', 'initComDataService', '$stateParams', 'trsHttpService', 'trsspliceString', '$filter', 'resourceCenterService', 'storageListenerService', '$q', function($scope, initComDataService, $stateParams, trsHttpService, trsspliceString, $filter, resourceCenterService, storageListenerService, $q) {
        initStatus();
        initData();

        /**
     * [initStatus description] 状态初始化
     * @return {[type]} [description]
     */
        function initStatus() {
            $scope.page = { // 分页信息
                CURRPAGE: 1,
                PAGESIZE: initPageSize(),
                ITEMCOUNT: 0
            };
            $scope.data = {
                items: [], // 列表数据
                selectedArray: [], // 复选框所选数据
                operFlags: [], // 取签见撤重
                suggestResult: '', // 搜索匹配结果
                suggestContentList: [], // 搜索匹配的内容列表
                itemCounts: 0 // 显示的稿件数量
            };
            $scope.params = { // 列表参数
                typeid: 'zyzx',
                serviceid: 'jtcpg',
                modelId: 'findFromNavigation',
                fcode: $stateParams.fcode,
                pageSize: $scope.page.PAGESIZE,
                pageNum: $scope.page.CURRPAGE,
                keyword: {
                    searchType: '0', // 查询类型
                    keywords: '', // 关键词
                    time: '', // 时间范围
                    area: '', // 地域
                    zyzxfield: '', // 主题
                    isOriginal: '', // 是否原创
                    isHead: '', // 是否头版
                    isRead: '', // 是否10w+
                    menuscriptType: '', // 稿件类型
                    timeLength: '0'
                }
            };
            $scope.status = {
                btnShow: false
            };
        }

        function initPageSize() {
            var parentWidth = $('.video_ul').width();
            var itemWidth = $('.video_item').width();
            var perColumn = parseInt(parentWidth / itemWidth);
            return perColumn * 4;
        }

        /**
     * [initData description] 数据初始化
     * @return {[type]} [description]
     */
        function initData() {
            initDropDown();
            requestData().then(function(result) {
                storageListenerService.previewPageTurningStorage(result, 'ZB_GUID', 'resourceVideoDetail');
            });

        }

        /**
     * [initDropDown description] 下拉框初始化
     * @return {[type]} [description]
     */
        function initDropDown() {
        // 时长字段
            $scope.durationType = {
                data: [{
                    dictName: '全部时长',
                    id: '0'
                },
                {
                    dictName: '1分钟以内',
                    id: '1'
                },
                {
                    dictName: '1-4分钟',
                    id: '2'
                }, {
                    dictName: '4-6分钟',
                    id: '3'
                }, {
                    dictName: '6分钟以上',
                    id: '4'
                }
                ],
                curValue: {
                    dictName: '全部时长',
                    id: '0'
                }
            };
        }

        /**
     * [requestData description]数据请求
     * @return {[type]} [description]
     */
        function requestData() {
            let deffer = $q.defer();
            $scope.data.selectedArray = [];
            var params = angular.copy($scope.params);
            params.keyword = JSON.stringify(params.keyword);
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(function(data) {
                if (data.result == 'success') {
                    $scope.data.items = data.content;
                    $scope.data.indexName = data.summary_info.indexName;
                    $scope.page.ITEMCOUNT = data.summary_info.ITEMCOUNT;
                    deffer.resolve(data.content);
                }
            });
            return deffer.promise;
        }

        /**
     * [selectDoc description] 选择/取消选择稿件对象
     * @param  {[object]} item [description] 稿件对象
     * @return {[type]}      [description]
     */
        $scope.selectDoc = function(item) {
            var index = $scope.data.selectedArray.indexOf(item);
            if (index < 0) {
                $scope.data.selectedArray.push(item);
            } else {
                $scope.data.selectedArray.splice(index, 1);
            }
        };

        /**
     * [searchWithKeyword description] 搜索
     * @param  {[String]} key   [description] 搜索条件
     * @param  {[String]} value [description] 搜索内容
     * @return {[type]}       [description]
     */
        $scope.searchWithKeyword = function(key, value) {
            if (key == 'time') {
                value = $scope.data.untildate ? $filter('date')($scope.data.fromdate, 'yyyy-MM-dd') + ',' + $filter('date')($scope.data.untildate, 'yyyy-MM-dd') : ''; // $filter('date')($scope.data.fromdate, 'yyyy/MM/dd').toString() ? $filter('date')($scope.data.fromdate, 'yyyy/MM/dd').toString() + "," + $filter('date')($scope.data.untildate, 'yyyy/MM/dd').toString() : "";
            }
            $scope.params.keyword[key] = value;
            $scope.params.pageNum = $scope.page.CURRPAGE = 1;
            $scope.data.items = [];
            requestData();
        };

        /**
     * [pageChanged description] 分页1
     * @return {[type]} [description]
     */
        $scope.pageChanged = function() {
            $scope.params.pageNum = $scope.page.CURRPAGE;
            requestData();
            resourceCenterService.scrollTop($element);
        };

        /**
     * [openPageForSearch description] 打开高级检索新页面
     * @return {[date]} [description]
     */
        $scope.openPageForSearch = function() {
            var url = $state.href('resadvancedsearch');
            window.open(url, '_blank');
        };
    }]);
